<template>
    <main>
        <div class="form-row">
            <div class="form-group col-md-6 ">
                <label class="form-label font-weight-bold">Fecha Toma muestra</label>
                <input type="date" class="form-control form-control-sm" v-model="fecha_lectura"
                    :class="{ 'is-invalid': $v.fecha_lectura.$error && $v.fecha_lectura.$dirty }">
            </div>
            <div class="form-group col-md-6">
                <label class="form-label font-weight-bold">Numero de Placa</label>
                <input type="number" v-model="numero" class="form-control form-control-sm"
                    :class="{ 'is-invalid': $v.numero.$error && $v.numero.$dirty }">
            </div>
        </div>
        <div class="card shadow-none">
            <div class="row p-2">
                <div class="form-group col-md-6">
                    <label class="form-label font-weight-bold">Aspecto del Cuello</label>
                    <select class="form-control form-control-sm" v-model="item.aspecto_cuello">
                        <option :value="item" v-for="(item, i) in cuello" :key="i">{{ item }}</option>
                    </select>
                </div>

                <div class="mt-4 py-2 col-md-6  ">

                    <button class="btn btn-primary btn-sm" @click="agregar()">
                        <i class="fas fa-plus"></i>&nbsp;Agregar
                    </button>
                </div>
            </div>

            <div class="table-responsive p-2">
                <table class="table table-sm">
                    <tr class="bg-gray-100">
                        <th>Aspecto del cuello </th>
                        <th></th>
                    </tr>
                    <tr v-for="(item, i) in items" :key="i">
                        <td>{{ item.aspecto_cuello }}</td>
                        <td>
                            <button class="btn btn-transparent" @click="eliminar()">
                                <i class="fas fa-times-circle text-danger"></i>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card shadow-none mt-2 p-2">
            <div class="form-row mt-2">
                <div class="form-group col-md-5">
                    <label class="form-label font-weight-bold">Tipo de tamizaje</label>
                    <select class="form-control form-control-sm" v-model="item_tamizaje.tipo_tamizaje">
                        <option value="">Seleccione...</option>
                        <option :value="item" v-for="(item, i) in tipo_tamizaje" :key="i">{{ item }}</option>
                    </select>
                </div>

                <div class="form-group col-md-5">
                    <label class="form-label font-weight-bold">Tipo de Muestra</label>
                    <select class="form-control form-control-sm" v-model="item_tamizaje.tipo_muestra">
                        <option value="">Seleccione...</option>
                        <option :value="item" v-for="(item, i) in tipo_muestra" :key="i">{{ item }}</option>
                    </select>
                </div>

                <div class="mt-4 py-2 col-md-2">
                    <button type="button" class="btn btn-primary btn-block btn-sm" @click="agregarTamizaje()">
                        <i class="fas fa-plus fa-fw"></i>Agregar
                    </button>
                </div>

                <div class="table-responsive col-md-12 mb-3" v-if="tamizajes_adicionados.length > 0">
                    <table class="table table-sm">
                        <tr class="bg-gray-100">
                            <th>Tipo de Tamizaje</th>
                            <th>Tipo de Muestra</th>
                            <th></th>
                        </tr>
                        <tr v-for="(item, i) in tamizajes_adicionados" :key="i">
                            <td>{{ item.tipo_tamizaje }}</td>
                            <td>{{ item.tipo_muestra }}</td>
                            <td>
                                <button type="button" class="btn btn-sm btn-transparent" @click="eliminarTamizaje(i)">
                                    <i class="fas fa-times-circle text-danger"></i>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="form-row mt-2">
            <div class="form-group col-md-12">
                <label class="form-label font-weight-bold">Observaciones</label>
                <textarea name="" id="" cols="30" rows="5" class="form-control" v-model="observaciones"></textarea>
            </div>
        </div>
    </main>
</template>
<script>
import { minLength, required } from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';

import Toast from '../../../../components/common/utilities/toast';
import tomaMuestrasService from "../../../../services/tomaMuestrasService";
export default {
    props: ['idHistoria', 'idUsuario', 'finalizada'],

    data() {
        return {
            cuello: ['AUSENTE', 'SANO', 'ATROFICO', 'CONGESTIVO', 'SANGRANTE', 'EROSIONADO', 'ULCERADO', 'POLIPO', 'LESION VISIBLE', 'ECTOPIA'],
            tipo_tamizaje: ['CITOLOGIA', 'TECNICA DE INSPECCION VISUAL', 'ADN/VPH'],
            tipo_muestra: ['CONVENCIONAL', 'PREPARACION EN BASE LIQUIDA'],

            item: {
                aspecto_cuello: {},
            },
            items: [],
            numero: '',
            fecha_lectura: '',
            item_tamizaje: {
                tipo_tamizaje: '',
                tipo_muestra: ''
            },
            tamizajes_adicionados: [],
            observaciones: '',
            id_historia_toma: ''
        }
    },
    validations() {
        return {
            numero: { required },
            fecha_lectura: { required },
            items: { required, minLength: minLength(1) },
            tamizajes_adicionados: { required, minLength: minLength(1) },
        }
    },
    methods: {
        agregar() {

            if (!this.item.aspecto_cuello || isEmpty(this.item.aspecto_cuello)) {
                Toast.fire({
                    icon: 'error',
                    title: 'Seleccione un aspecto del cuello'
                });
                return;
            }
            this.items.push({ ...this.item });
            this.item.aspecto_cuello = {};

        },
        eliminar(index) {
            this.items.splice(index, 1);
        },
        agregarTamizaje() {
            if (!this.item_tamizaje.tipo_tamizaje || !this.item_tamizaje.tipo_muestra) {
                Toast.fire({
                    icon: 'error',
                    title: 'Seleccione tipo de tamizaje y tipo de muestra'
                });
                return;
            }


            const existe = this.tamizajes_adicionados.some(
                x => x.tipo_tamizaje === this.item_tamizaje.tipo_tamizaje && x.tipo_muestra === this.item_tamizaje.tipo_muestra
            );

            if (existe) {
                Toast.fire({
                    icon: 'warning',
                    title: 'Esta combinación ya ha sido agregada'
                });
                return;
            }

            this.tamizajes_adicionados.push({ ...this.item_tamizaje });
            this.item_tamizaje.tipo_tamizaje = '';
            this.item_tamizaje.tipo_muestra = '';
        },
        eliminarTamizaje(index) {
            this.tamizajes_adicionados.splice(index, 1);
        },
        async save() {
            try {

                this.$v.numero.$touch();
                this.$v.fecha_lectura.$touch();

                if (this.$v.numero.$invalid || this.$v.fecha_lectura.$invalid) return;

                 if (isEmpty(this.items)) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Debe agregar un aspecto de cuello'
                    });
                    return;
                }
                if (isEmpty(this.tamizajes_adicionados)) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Debe agregar al menos un tipo de tamizaje y tipo de muestra'
                    });
                    return;
                }

                let muestras = {
                    id_historia: this.idHistoria,
                    numero_placa: this.numero,
                    fecha_lectura: this.fecha_lectura,
                    tamizajes: this.tamizajes_adicionados,
                    observaciones: this.observaciones,
                    cuello: this.items,
                }

                this.LoaderSpinnerShow();

                if (this.id_historia_toma !== '') {
                    muestras.id = this.id_historia_toma;
                    await tomaMuestrasService.update(muestras);
                } else {
                    await tomaMuestrasService.store(muestras);
                }

                const res = await tomaMuestrasService.showByHc(this.idHistoria);
                if (!isEmpty(res.data)) {
                    const data = Array.isArray(res.data) ? res.data[0] : res.data;
                    this.id_historia_toma = data ? data.id : '';
                }


                this.LoaderSpinnerHide();

                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con exito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        }
    },
    watch: {
        finalizada: async function (value) {

            if (value === 'N') {
                const response = await tomaMuestrasService.showByHc(this.idHistoria);
                if (!isEmpty(response.data)) {
                    const data = Array.isArray(response.data) ? response.data[0] : response.data;
                    this.observaciones = data.observaciones;
                    this.fecha_lectura = data.fecha_lectura;
                    this.numero = data.numero_placa;
                    this.id_historia_toma = data.id;

                    this.tamizajes_adicionados = [];
                    if (Array.isArray(response.data)) {
                        response.data.forEach(toma => {
                            if (toma.tipo_tamizaje || toma.tipo_muestra) {
                                this.tamizajes_adicionados.push({
                                    tipo_tamizaje: toma.tipo_tamizaje || '',
                                    tipo_muestra: toma.tipo_muestra || ''
                                });
                            }
                        });
                    } else {
                        let tamizajes = response.data.tipo_tamizaje ? response.data.tipo_tamizaje.split(', ') : [];
                        let muestras_lista = response.data.tipo_muestra ? response.data.tipo_muestra.split(', ') : [];
                        for (let i = 0; i < Math.max(tamizajes.length, muestras_lista.length); i++) {
                            this.tamizajes_adicionados.push({
                                tipo_tamizaje: tamizajes[i] || '',
                                tipo_muestra: muestras_lista[i] || ''
                            });
                        }
                    }

                    this.items = data.aspectos ? data.aspectos.map(x => {
                        return {
                            aspecto_cuello: x.aspecto,
                        }
                    }) : [];

                }

            }
        }
    },
    async created() {
        if (this.finalizada === 'N') {
            const response = await tomaMuestrasService.showByHc(this.idHistoria);
            if (!isEmpty(response.data)) {
                const data = Array.isArray(response.data) ? response.data[0] : response.data;
                this.observaciones = data.observaciones;
                this.fecha_lectura = data.fecha_lectura;
                this.numero = data.numero_placa;
                this.id_historia_toma = data.id;

                this.tamizajes_adicionados = [];
                if (Array.isArray(response.data)) {
                    response.data.forEach(toma => {
                        if (toma.tipo_tamizaje || toma.tipo_muestra) {
                            this.tamizajes_adicionados.push({
                                tipo_tamizaje: toma.tipo_tamizaje || '',
                                tipo_muestra: toma.tipo_muestra || ''
                            });
                        }
                    });
                } else {
                    let tamizajes = response.data.tipo_tamizaje ? response.data.tipo_tamizaje.split(', ') : [];
                    let muestras_lista = response.data.tipo_muestra ? response.data.tipo_muestra.split(', ') : [];
                    for (let i = 0; i < Math.max(tamizajes.length, muestras_lista.length); i++) {
                        this.tamizajes_adicionados.push({
                            tipo_tamizaje: tamizajes[i] || '',
                            tipo_muestra: muestras_lista[i] || ''
                        });
                    }
                }

                this.items = data.aspectos ? data.aspectos.map(x => {
                    return {
                        aspecto_cuello: x.aspecto,
                    }
                }) : [];

            }
        }
    }

}
</script>
